import api from "@/lib/api";

// Single source for lazy page loaders (used by App.js router + hover prefetch).
export const pageImporters = {
  "/dashboard": () => import("@/pages/Dashboard"),
  "/interventi": () => import("@/pages/Interventi"),
  "/appalti": () => import("@/pages/Appalti"),
  "/listini": () => import("@/pages/Listini"),
  "/tipi-lavoro": () => import("@/pages/TipiLavoro"),
  "/dipendenti": () => import("@/pages/Dipendenti"),
  "/presenze": () => import("@/pages/Presenze"),
  "/caratterizzazioni": () => import("@/pages/Caratterizzazioni"),
  "/utenti": () => import("@/pages/Utenti"),
  "/inviti": () => import("@/pages/Inviti"),
  "/report": () => import("@/pages/Reports"),
  "/report-mensile": () => import("@/pages/ReportMensile"),
  "/report-dipendenti": () => import("@/pages/ReportDipendenti"),
  "/impostazioni": () => import("@/pages/Impostazioni"),
  "/documenti": () => import("@/pages/Documenti"),
  "/subappalti": () => import("@/pages/Subappalti"),
};

const get = (url) => async () => (await api.get(url)).data;

// Primary data each route needs, so navigation renders instantly from cache.
const dataPrefetch = {
  "/dashboard": (qc) => qc.prefetchQuery({ queryKey: ["stats"], queryFn: get("/stats") }),
  "/interventi": (qc) => {
    qc.prefetchQuery({ queryKey: ["interventions", false], queryFn: get("/interventions?include_deleted=false") });
    qc.prefetchQuery({ queryKey: ["work_types"], queryFn: get("/work_types") });
    qc.prefetchQuery({ queryKey: ["users"], queryFn: get("/users") });
    qc.prefetchQuery({ queryKey: ["appalti"], queryFn: get("/appalti") });
    qc.prefetchQuery({ queryKey: ["listini"], queryFn: get("/listini") });
    qc.prefetchQuery({ queryKey: ["dipendenti"], queryFn: get("/dipendenti") });
  },
  "/appalti": (qc) => qc.prefetchQuery({ queryKey: ["appalti"], queryFn: get("/appalti") }),
  "/listini": (qc) => {
    qc.prefetchQuery({ queryKey: ["listini"], queryFn: get("/listini") });
    qc.prefetchQuery({ queryKey: ["appalti"], queryFn: get("/appalti") });
  },
  "/tipi-lavoro": (qc) => {
    qc.prefetchQuery({ queryKey: ["work_types"], queryFn: get("/work_types") });
    qc.prefetchQuery({ queryKey: ["appalti"], queryFn: get("/appalti") });
  },
  "/dipendenti": (qc) => qc.prefetchQuery({ queryKey: ["dipendenti"], queryFn: get("/dipendenti") }),
  "/presenze": (qc) => qc.prefetchQuery({ queryKey: ["dipendenti"], queryFn: get("/dipendenti") }),
  "/caratterizzazioni": (qc) => qc.prefetchQuery({ queryKey: ["caratterizzazioni"], queryFn: get("/caratterizzazioni") }),
  "/utenti": (qc) => qc.prefetchQuery({ queryKey: ["users"], queryFn: get("/users") }),
  "/inviti": (qc) => qc.prefetchQuery({ queryKey: ["allowed_emails"], queryFn: get("/allowed_emails") }),
  "/report": (qc) => qc.prefetchQuery({ queryKey: ["production"], queryFn: get("/reports/production") }),
  "/report-mensile": (qc) => {
    qc.prefetchQuery({ queryKey: ["appalti"], queryFn: get("/appalti") });
    qc.prefetchQuery({ queryKey: ["company"], queryFn: get("/settings/company") });
  },
  "/impostazioni": (qc) => qc.prefetchQuery({ queryKey: ["company"], queryFn: get("/settings/company") }),
  "/documenti": (qc) => qc.prefetchQuery({ queryKey: ["files", "company", null], queryFn: get("/files?context=company") }),
  "/subappalti": (qc) => qc.prefetchQuery({ queryKey: ["subappalti"], queryFn: get("/subappalti") }),
};

const dataDone = new Set();

// Prefetch the JS chunk (cheap, deduped by the bundler) and, once, the route data.
export function prefetchRoute(to, qc) {
  const imp = pageImporters[to];
  if (imp) imp();
  if (!qc || dataDone.has(to)) return;
  dataDone.add(to);
  const fn = dataPrefetch[to];
  if (fn) fn(qc);
}

// Warm all route chunks (used on menu open) — JS only, no network data.
export function prefetchAllChunks() {
  Object.values(pageImporters).forEach((imp) => imp());
}
